import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async loadUser( _, params){
      return await axios.get('/users', { params })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async createUser( _, formData){
      return await axios.post('/users', formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadUserDetail( _, id){
      return await axios.get(`/users/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateUser( _, {id, formData}){
      return await axios.post(`/users/${id}`, formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async destroyUser( _, id){
      return await axios.delete(`/users/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    }
  },
};
